import { Toolbar, Box, CssBaseline } from '@mui/material';
import { AppBar } from '../../components/DashboardComponents';
import agrowelogo from '../../assets/pictures/agrowelogo.png';
export default function Bar(props) {
  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="fixed" open={false}>
          <Toolbar sx={{ paddingRight: 24 }}>
            <img src={agrowelogo} alt="logo" height={'50vh'} />
          </Toolbar>
        </AppBar>
        <Box
          component="main"
          sx={{
            mt: 10,
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
            py: 2,
            px: 4,
          }}
        >
          {props.content && <props.content />}
        </Box>
      </Box>
    </>
  );
}
